// Shared with the server's Host-header resolution (VIP-12037), so browser and
// SSR never disagree on which site a host belongs to.
export const LOCAL_MAPPING = {
  'vicampo.de': 'de',
  'vicampo.at': 'at',
  'vicampo.ch': 'ch',
  'vicampo.test': 'de',
  'vicampo-at.test': 'at',
  'vicampo-ch.test': 'ch'
}

const devMode = import.meta.env.VITE_APP_DEV_MODE === 'ON'
const API_REGEX = /^(www.|fe-app.)?/

class EnvironmentHelper {
  static detectTopLevelDomain() {
    // SiteConfig takes its config map from the TLD but its domain/apiRoot from
    // detectDomain(), so both must come from the same host or an SSR render
    // pairs one shop's siteId, lang and currency with another shop's api root.
    // There is no `location` on the server, so the domain is the source there
    // until site resolution becomes per-request (Host header).
    const hostname = import.meta.env.SSR
      ? EnvironmentHelper.detectDomain()
      : location.hostname
    if (!devMode) {
      return _getTopLevelDomain(hostname)
    }
    return LOCAL_MAPPING[_getDevDomain(hostname)] || 'de'
  }

  static detectDomain() {
    if (import.meta.env.SSR) {
      return import.meta.env.VITE_APP_DOMAIN || 'www.vicampo.de'
    }
    if (devMode) {
      return import.meta.env.VITE_APP_DOMAIN || location.hostname
    }
    return location.hostname.replace('fe-app.', 'www.')
  }

  static detectApiDomain(domain) {
    return domain.replace(API_REGEX, 'api.')
  }
}

const _getDevDomain = (hostname) => hostname?.split('.').slice(-2).join('.')
const _getTopLevelDomain = (hostname) => {
  const levels = hostname.split('.')
  return levels.at(-1)
}

export default EnvironmentHelper
